import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

const LinearIndeterminate: React.FC = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgress />
    </Box>
  );
};

export default LinearIndeterminate;
